class PasswordRequestView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      email: this.props.email
    };
  }

  setEmail(evt) {
    this.setState({
      email: evt.target.value
    });
  }

  submit(evt) {
    let data = {
      email: this.state.email,
      accountType: "BRC2"
    };

    this.setState({
      submitted: true
    });

    mc.ajax.post("/users/resets", data).catch(function (err) {
      // TODO catch error
    });

    evt.preventDefault();
  }

  static open(email = "") {
    let opts = {
      minWidth: "500px",
      maxWidth: "600px",
      height: "400px",
      verticalAlign: "center"
    };

    mc.ui.modal(<PasswordRequestView email={email}/>, opts);
  }

  render() {
    let { email, submitted } = this.state;
    let valid = email.match(/.+@.+\..+/);

    let form = (
      <div>
        <img src="./img/mc/error.svg" width="95" height="92"/>
        <p>{tx("enter_email_address")}</p>
        <form onSubmit={(e) => this.submit(e)}>
          <input
            type="text"
            size="30"
            name="email"
            autoCorrect="off"
            autoCapitalize="off"
            value={email}
            onChange={(e) => this.setEmail(e)}/><br/>
          <button name="submit" className="mc-button" disabled={!valid}>
            {tx("submit")}
          </button>
        </form>
      </div>
    );

    let result = <p>{"Thanks! Please check your email."}</p>;

    return (
      <div className="rc-password-request-view">
        {submitted ? result : form}
      </div>
    );
  }
}

module.exports = PasswordRequestView;